var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.17157 1.17157C0 2.34315 0 4.22876 0 8C0 11.7712 0 13.6569 1.17157 14.8284C2.34315 16 4.22876 16 8 16C11.7712 16 13.6569 16 14.8284 14.8284C16 13.6569 16 11.7712 16 8.00001C16 4.22879 16 2.34314 14.8284 1.17157C13.6569 0 11.7712 0 8 0C4.22876 0 2.34315 0 1.17157 1.17157ZM5.80697 4.77916C6.05046 4.5544 6.06564 4.17481 5.84088 3.93131C5.61612 3.68782 5.23652 3.67264 4.99303 3.8974L3.19303 5.55894C3.06998 5.67252 3 5.83236 3 5.99982C3 6.16728 3.06998 6.32712 3.19303 6.4407L4.99303 8.10224C5.23652 8.327 5.61612 8.31182 5.84088 8.06833C6.06564 7.82483 6.05046 7.44524 5.80697 7.22048L5.13459 6.59982H9.63076C10.8288 6.59982 11.8 7.57102 11.8 8.76905C11.8 9.96708 10.8288 10.9383 9.63077 10.9383H6C5.66863 10.9383 5.4 11.2069 5.4 11.5383C5.4 11.8697 5.66863 12.1383 6 12.1383H9.63077C11.4915 12.1383 13 10.6298 13 8.76905C13 6.90827 11.4915 5.39982 9.63076 5.39982H5.13459L5.80697 4.77916Z",
    fill: "#FFE600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/Undo.593999c95275250e96b6e149fb3c87de.svg";
export { ForwardRef as ReactComponent };